var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPartlyCloudy01 = function SvgPartlyCloudy01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "partly_cloudy-01_svg2__a",
    x1: 2.56,
    x2: 135.67,
    y1: 136.32,
    y2: 3.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#partly_cloudy-01_svg2__a",
    id: "partly_cloudy-01_svg2__b",
    x1: 32.61,
    x2: 165.72,
    y1: 166.37,
    y2: 33.26
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#partly_cloudy-01_svg2__a",
    id: "partly_cloudy-01_svg2__c",
    x1: 4.65,
    x2: 137.76,
    y1: 138.41,
    y2: 5.3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#partly_cloudy-01_svg2__a",
    id: "partly_cloudy-01_svg2__d",
    x1: 32.61,
    x2: 165.72,
    y1: 166.37,
    y2: 33.26
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M51.6 87.14a49.34 49.34 0 0 1 24.54-30.58c1.75-.91 3.91-.22 4.81 1.53.9 1.73.24 3.86-1.48 4.79a42.17 42.17 0 0 0-20.98 26.14 3.576 3.576 0 0 1-4.39 2.5 3.555 3.555 0 0 1-2.5-4.37Z",
    style: {
      fill: "url(#partly_cloudy-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4 25V3.57C95.4 1.6 97 0 98.97 0s3.57 1.6 3.57 3.57V25c0 1.97-1.6 3.57-3.57 3.57S95.4 26.97 95.4 25m-30.84 8.26-7.14-12.37a3.573 3.573 0 0 0-6.19 3.57l7.14 12.37c.99 1.7 3.18 2.28 4.89 1.29a3.58 3.58 0 0 0 1.3-4.86M23.97 96.43H9.68c-1.97 0-3.57 1.6-3.57 3.57s1.6 3.57 3.57 3.57h14.29c1.97 0 3.57-1.6 3.57-3.57s-1.6-3.57-3.57-3.57m33.45 82.68 7.14-12.37a3.572 3.572 0 0 0-6.19-3.57l-7.14 12.37c-.97 1.72-.36 3.9 1.36 4.87 1.69.96 3.84.38 4.83-1.3m89.29-3.57-7.14-12.37a3.573 3.573 0 0 0-6.19 3.57l7.14 12.37c.99 1.7 3.18 2.28 4.88 1.29 1.69-.99 2.28-3.16 1.3-4.86m41.56-79.11h-14.29c-1.97 0-3.57 1.6-3.57 3.57s1.6 3.57 3.57 3.57h14.29c1.97 0 3.57-1.6 3.57-3.57s-1.6-3.57-3.57-3.57m-48.7-59.6 7.14-12.37a3.572 3.572 0 0 0-6.19-3.57l-7.14 12.37c-.97 1.72-.36 3.9 1.37 4.86 1.69.95 3.83.38 4.82-1.29M35.8 59.41 17.24 48.7a3.572 3.572 0 0 0-3.57 6.19L32.23 65.6c1.71.98 3.9.38 4.87-1.34.97-1.7.39-3.86-1.3-4.85m66.74 137.02V175c0-1.97-1.6-3.57-3.57-3.57s-3.57 1.6-3.57 3.57v21.43c0 1.97 1.6 3.57 3.57 3.57s3.57-1.6 3.57-3.57m81.73-51.31-18.56-10.71c-1.72-.97-3.9-.37-4.87 1.35-.96 1.7-.39 3.85 1.3 4.84l18.56 10.71c1.71.98 3.9.38 4.87-1.34.97-1.7.39-3.86-1.3-4.85",
    style: {
      fill: "url(#partly_cloudy-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.49 56.14c0 1.97-1.6 3.57-3.57 3.57s-3.57-1.6-3.57-3.57 1.6-3.57 3.57-3.57 3.57 1.6 3.57 3.57",
    style: {
      fill: "url(#partly_cloudy-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.54 52.31c-5.95-12.33-20.76-17.5-33.09-11.55a24.8 24.8 0 0 0-11.78 12.04c-26.06-20.27-63.63-15.58-83.9 10.49A59.75 59.75 0 0 0 39.18 100c.01 2.12.14 4.24.37 6.35-10.82.93-19.74 8.84-21.98 19.46-8.91-.7-16.7 5.96-17.4 14.88-.7 8.91 5.96 16.7 14.88 17.4.45.03.9.05 1.36.05h47.58c3.94-.02 7.78-1.21 11.04-3.41 7.54 3.34 15.7 5.07 23.94 5.08 32.98.04 59.75-26.66 59.8-59.64 0-3.31-.27-6.61-.81-9.87h22.38c9.44.09 17.58-6.61 19.29-15.89 1.68-10.38-5.38-20.16-15.76-21.84-1.1-.18-2.22-.26-3.33-.24ZM16.41 150.99a9.07 9.07 0 0 1-9.05-10.27c.75-5.01 5.43-8.46 10.44-7.71.15.02.31.05.46.08 2.74.57 5.43-1.19 6-3.93.03-.14.05-.29.07-.43 1.23-9.67 10.07-16.52 19.74-15.29 6.28.8 11.65 4.89 14.08 10.74a5.12 5.12 0 0 0 5.22 3.17c6.55-.61 12.35 4.21 12.96 10.76.09 1 .06 2.01-.1 3-1.14 5.83-6.3 9.99-12.24 9.88zm82.56 1.66c-6.32 0-12.58-1.15-18.49-3.39 1.42-2.11 2.37-4.51 2.8-7.02 1.68-10.38-5.38-20.16-15.77-21.84q-1.65-.27-3.33-.24a24.54 24.54 0 0 0-17.39-13.46c-.3-2.22-.46-4.46-.47-6.7 0-29.07 23.55-52.64 52.62-52.65 11.51 0 22.7 3.76 31.86 10.73-8.86 1.01-15.23 9.01-14.23 17.87.93 8.22 7.92 14.4 16.19 14.33h17.87c5.59 28.31-12.82 55.79-41.13 61.39-3.47.69-7 1.02-10.53.99Zm93.61-79.39c-1.14 5.83-6.3 9.99-12.24 9.88h-47.58c-5.01.03-9.1-4-9.14-9.02 0-.42.02-.84.08-1.25.76-5.01 5.43-8.46 10.45-7.71.15.02.31.05.46.08 2.75.57 5.43-1.19 6.01-3.94.03-.14.05-.29.07-.43 1.23-9.67 10.07-16.52 19.74-15.29 6.28.8 11.65 4.89 14.08 10.73a5.16 5.16 0 0 0 5.22 3.18c6.55-.61 12.35 4.2 12.96 10.75.09 1 .06 2.02-.1 3.01Z",
    style: {
      fill: "url(#partly_cloudy-01_svg2__d)"
    }
  }));
};
export default SvgPartlyCloudy01;